import { createAction } from "redux-starter-kit";
import get from "lodash/get";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";

import {
  UPDATE_NOTES_FAILURE,
  UPDATE_NOTES_REQUEST,
  UPDATE_NOTES_SUCCESS
} from "../types";
import awsImageUpload from "../../../helpers/awsImageUpload";

const updateNotes = (paymentProfileId, noteId, object) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(
      createAction(UPDATE_NOTES_REQUEST)({
        noteId
      })
    );
    const response = await api.payments.updatePaymentProfileNotes(
      paymentProfileId,
      noteId,
      object
    );
    if (object.attachments && object.attachments.name) {
      const attachmentsKeys = get(response, `attachments`, []);
      await awsImageUpload(
        [object.attachments].map(attachment => ({
          file: attachment,
          upload_url: attachmentsKeys[0].upload_url
        }))
      );
    }
    const data = normalize([response], [schema.paymentBillingNotes]);
    dispatch(addEntities(data.entities));
    dispatch(createAction(UPDATE_NOTES_SUCCESS)({ [noteId]: data.result }));
    return response;
  } catch (err) {
    dispatch(createAction(UPDATE_NOTES_FAILURE)(err));
    throw err;
  }
};

export default updateNotes;
